export default "__VITE_ASSET__YUBF2A5z__"